import React from "react";
import { DateTime } from "luxon";
import { ChevronLeftIcon, ChevronRightIcon } from "@taskpane/icons";
import css from "./DatePickerHeader.module.scss";

export interface DatePickerHeaderProps {
  date: Date;
  prevMonthButtonDisabled: boolean;
  nextMonthButtonDisabled: boolean;
  decreaseMonth: () => void;
  increaseMonth: () => void;
}

const DatePickerHeader: React.FC<DatePickerHeaderProps> = ({
  date,
  prevMonthButtonDisabled,
  nextMonthButtonDisabled,
  decreaseMonth,
  increaseMonth,
}) => {
  const dateString = DateTime.fromJSDate(date).toFormat("MMMM, yyyy");

  const attrs = {
    container: {
      className: css.container,
    },
    prevMonthButton: {
      type: "button" as const,
      "aria-label": "Previous month",
      className: css.button,
      disabled: prevMonthButtonDisabled,
      onClick: decreaseMonth,
    },
    nextMonthButton: {
      type: "button" as const,
      "aria-label": "Next month",
      className: css.button,
      disabled: nextMonthButtonDisabled,
      onClick: increaseMonth,
    },
    title: {
      className: css.title,
    },
    icon: {
      className: css.icon,
    },
  };

  return (
    <div {...attrs.container}>
      <button {...attrs.prevMonthButton}>
        <ChevronLeftIcon {...attrs.icon} />
      </button>
      <span {...attrs.title}>{dateString}</span>
      <button {...attrs.nextMonthButton}>
        <ChevronRightIcon {...attrs.icon} />
      </button>
    </div>
  );
};

export default DatePickerHeader;
